import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import { Link } from 'react-router-dom';
import CartButton from '../../Cart/CartButton';
import CartFlyout from '../../Cart/CartFlyout';
import { ReactComponent as Pin26 } from '../../../svg/Pin26.svg';
import { ReactComponent as Phone26 } from '../../../svg/Phone26.svg';
import { theme } from '../../Theme';

const HeaderButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 -8px -4px;

  a + a {
    margin-left: 64px;
  }

  ${theme.above.lg} {
    .cart-button {
      padding-top: 3px;
      border: 1px solid red;
    }
  }
`;

const StyledLink = styled(Link)`
  height: 53px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${theme.colors.white};
  padding: 8px;
  padding-bottom: 4px;
  border-radius: 4px;
  text-decoration: none;

  svg {
    width: 20px;
    height: 20px;
    color: black;
  }

  span {
    margin-top: 5px;
    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    color: #333333;
  }

  &:hover {
    background: ${theme.colors.notWhite};
  }
`;

const HeaderButtons = () => {
  return (
    <>
      <HeaderButtonsWrapper>
        <StyledLink to="/butiker">
          <Pin26 />
          <span>{t('Stores')}</span>
        </StyledLink>
        <StyledLink to="/kontakta-oss">
          <Phone26 />
          <span>{t('Contact')}</span>
        </StyledLink>
        <CartButton />
      </HeaderButtonsWrapper>
      <CartFlyout />
    </>
  );
};

export default HeaderButtons;
